{
  "accent": "Màu nhấn",
  "width": "Chiều rộng",
  "showCovers": "Hiển thị ảnh bìa",
  "showTrackNumber": "Hiển thị số bài hát",
  "showFileExtension": "Hiển thị phần mở rộng tệp",
  "trackInfoAlign": "Căn lề thông tin bài hát",
  "trackInfoAlignLeft": "trái",
  "trackInfoAlignRight": "phải"
}
